import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-noeal',
  templateUrl: './noeal.component.html',
  styleUrls: ['./noeal.component.css']
})
export class NoealComponent implements OnInit {
submitted=false;
@Input() hammadde:any;
  constructor( private activeModal:NgbActiveModal,) { }
data:any;
  ngOnInit() {
  }  close(){
    this.activeModal.close();
  }

  save(){

    this.hammadde.noael=this.data;
 this.activeModal.close(this.hammadde);
  }

}
